<div class="retailer-commission-container">
    <div class="section-menu-items">
        <button
          mat-flat-button
          class="item-each"
          [routerLink]="['edit-consumer',userId]"
          routerLinkActive="router-link-active"
        >
        <span translate class="translate">Edit Consumer</span
          ><mat-icon class="ms-2">add_box</mat-icon>
        </button>
        <button
        mat-flat-button
        class="item-each"
        [routerLink]="['loyalty-point-history',userId]"
        routerLinkActive="router-link-active"
      >
      <span translate class="translate">pages.ManageConsumer.LoyaltyPointsHistory</span><mat-icon class="ms-2"
          >restore</mat-icon
        >
      </button>
        <button
          mat-flat-button
          class="item-each"
          [routerLink]="['promocode-history',userId]"
          routerLinkActive="router-link-active"
        >
        <span translate class="translate">pages.ManageConsumer.Promocodehistory</span><mat-icon class="ms-2"
            >restore</mat-icon
          >
        </button>
        <button mat-flat-button  class="item-each"
        [routerLink]="['consumer-logs',userId]"
         routerLinkActive="router-link-active">
        <span translate class="translate">pages.ManageConsumer.Logs</span>
        <mat-icon class="ms-2">summarize</mat-icon>
        </button>
        <button
        mat-flat-button
        class="item-each"
        [routerLink]="['transaction',userId]"
        routerLinkActive="router-link-active"
      >
      <span translate class="translate">pages.newRetailer.transactionHistory</span><mat-icon class="ms-2"
          >restore</mat-icon
        >
      </button>
        <button
        mat-flat-button
        class="item-each"
        [routerLink]="['payment-history',userId]"
        routerLinkActive="router-link-active"
        >
        <span translate class="translate">pages.newRetailer.paymentHistory</span><mat-icon class="ms-2"
            >credit_card</mat-icon
          >
        </button>
        <button
        mat-flat-button
        class="item-each"
        [routerLink]="['comments',userId]"
        routerLinkActive="router-link-active"
        >
        <span translate class="translate">pages.newRetailer.comments</span><mat-icon class="ms-2"
            >credit_card</mat-icon
          >
        </button>
      </div>
      <router-outlet></router-outlet>
    </div>
